<div
  class="html-container"
  [innerHTML]="sanitizedHtml"
  (click)="handleShowMore($event)"
></div>
